import { IonApp, IonContent, IonPage } from "@ionic/react";
import AccountDashboard from "components/mobile-components/AccountDashboard";
import DashboardBottomSheet from "components/mobile-components/Accounts/DashboardBottomSheet";
import DepositAndPaymentDue from "components/mobile-components/Accounts/DepositAndPaymentDue";
import ServiceProviderAndTax from "components/mobile-components/Accounts/ServiceProviderAndTax";
import BazAiBottomChatArea from "components/mobile-components/BazAI/BazAiBottomChatArea";
import BackButtonTitle from "components/mobile-components/Common/BackButtonTitle";
import BazAiTextArea from "components/mobile-components/Home/BazAiTextArea";
import MonthlyRevenueExpense from "components/mobile-components/Home/MonthlyRevenueExpense";
import ProfitLossEmployee from "components/mobile-components/Home/ProfitLossEmployee";
import { getLocalUser, getUser, getUserBusiness } from "config/user";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Accounts from "services/Accounts";
import Product from "services/Product";

export default function AccountDashboardPage() {
  const isOpenBottomSheet = useSelector((state) => state.user.dashboardSheet);
  const messageData = useSelector((state) => state?.bazAi?.data);
  const [multiBusiness, setMultiBusiness] = useState(false);
  const textareaRef = useRef(null);
  const [height, setHeight] = useState(50);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const ekkLanguage = useSelector((state) => state.lan.lan);
  const user = getUser() ? getUser() : getLocalUser()?.user;
  const business = getUserBusiness();
  let [monthlyExpense, setMonthlyExpense] = useState(null);
  let [monthlyRevenue, setMonthlyRevenue] = useState(null);
  let [monthlyProfitLoss, setMonthlyProfitLoss] = useState(null);
  let [totalEmployee, setTotalEmployee] = useState({
    count: 0,
    amount: 0,
    currency: "",
  });
  let [erLoading, setErLoading] = useState(false);
  let [plLoading, setPlLoading] = useState(false);
  let [dLoading, setDLoading] = useState(false);
  let [epDLoading, setepDLoading] = useState(false);
  let [sLoading, setSLoading] = useState(false);
  let [tLoading, setTLoading] = useState(false);
  let [employeeLoading, setEmployeeLoading] = useState(false);
  const [depositExpenseDue, setDepositExpenseDue] = useState({});
  const [serviceAmountAndTax, setServiceAmountAndTax] = useState({});
  const startDay = moment().startOf("month").format("YYYY-MM-DD");
  const endDay = moment().endOf("month").format("YYYY-MM-DD");

  useEffect(() => {
    if (timeZone) {
      getMonthlyExpenseRevenue();
      getDepositAndExpenseDue();
      getServiceAmountAndTax();
      getMonthlyProfitLoss();
      getEmployeeCount();
    }
  }, [timeZone]);

  const getMonthlyExpenseRevenue = async () => {
    try {
      setErLoading(true);
      const [revenueRes, expenseRes] = await Promise.all([
        Accounts.getCurrentMonthRevenue(timeZone),
        Accounts.getCurrentMonthExpense(timeZone),
      ]);

      if (revenueRes.status === 200) {
       
        setMonthlyRevenue({
          revenue_count: revenueRes.count,
          total_revenue: revenueRes.total_amount,
          currency: revenueRes?.currency,
        });
      } else {
        setMonthlyRevenue(null);
      }

      if (expenseRes.status === 200) {
        setMonthlyExpense({
   
          expense_count: expenseRes.count,
          total_expense: expenseRes.total_amount,
          currency: revenueRes?.currency,
        });
      } else {
        setMonthlyExpense(null);
      }
    } catch (err) {
      console.error("Revenue/Expense API Error:", err);
      setMonthlyExpense(null);
      setMonthlyRevenue(null);
    } finally {
      setErLoading(false);
    }
  };

  const getDepositAndExpenseDue = async () => {
    try {
      setDLoading(true);
      setepDLoading(true);
      const [depositRes, expenseRes] = await Promise.all([
        Accounts.getDepositCard(timeZone),
        Accounts.getExpenseDueCard(timeZone),
      ]);

      if (depositRes.status === 200) {
        setDepositExpenseDue((prev) => ({
          ...prev,
          total_deposit: depositRes.total_amount,
          currency: depositRes.currency,
        }));
      }

      if (expenseRes.status === 200) {
        setDepositExpenseDue((prev) => ({
          ...prev,
          total_due: expenseRes.total_amount,
          currency: expenseRes.currency,
        }));
      }
    } catch (err) {
      console.error("Deposit/Expense Due API Error:", err);
    } finally {
      setDLoading(false);
      setepDLoading(false);
    }
  };

  const getServiceAmountAndTax = async () => {
    try {
      setSLoading(true);
      setTLoading(true);
      const [serviceRes, taxRes] = await Promise.all([
        Accounts.getServiceAmountCard(timeZone),
        Accounts.getTax(timeZone),
      ]);

      if (serviceRes.status === 200) {
        setServiceAmountAndTax((prev) => ({
          ...prev,
          total_provider_amount: serviceRes.total_amount,
          currency: serviceRes.currency,
        }));
      }

      if (taxRes.status === 200) {
        setServiceAmountAndTax((prev) => ({
          ...prev,
          total_tax: taxRes.total_tax,
          currency: taxRes.currency,
        }));
      }
    } catch (err) {
      console.error("Service/Tax API Error:", err);
    } finally {
      setSLoading(false);
      setTLoading(false);
    }
  };

  const getMonthlyProfitLoss = async () => {
    try {
      setPlLoading(true);
      const response = await Accounts.getProfitLossCard(timeZone);

      if (response.status === 200) {
        setMonthlyProfitLoss({
          profit: response.profit,
          loss: response.loss,
          currency: response.currency,
        });
      } else {
        setMonthlyProfitLoss(null);
      }
    } catch (err) {
      console.error("Profit/Loss API Error:", err);
      setMonthlyProfitLoss(null);
    } finally {
      setPlLoading(false);
    }
  };

  const getEmployeeCount = async () => {
    try {
      setEmployeeLoading(true);
      const response = await Accounts.getEmployeeCard(timeZone);

      if (response.status === 200) {
        setTotalEmployee({
          count: response?.count,
          amount: response?.all_emp_total_salary,
          currency: response?.currency,
        });
      } else {
        setTotalEmployee(null);
      }
    } catch (err) {
      console.error("Employee Count API Error:", err);
      setTotalEmployee(null);
    } finally {
      setEmployeeLoading(false);
    }
  };

  useEffect(() => {
    const checkMultiBusiness = async () => {
      const response = await Product.checkMultiBusiness();
      if (response.status === 200) {
        setMultiBusiness(response?.is_multi_business);
      }
    };
    checkMultiBusiness();
  }, []);
  return (
    <IonApp>
      <IonPage>
        <IonContent>
          <BackButtonTitle
            title="Dashboard"
            // from={multiBusiness ? "dashboard" : ""}
          />
          <div className="h-full overflow-y-auto px-2 pt-14 pb-[100px]">
            {" "}
            <div className="flex items-start gap-2 px-2 my-5">
              {/* AI Avatar */}
              <img
                src="assets/images/bot-s.png" // Replace with the actual image path
                alt="Ana Avatar"
                className="w-8 h-8 rounded-full object-cover"
              />

              {/* Chat Message */}
              <div className="bg-white px-4 py-2 rounded-tr-xl rounded-bl-xl rounded-br-xl max-w-md shadow-md">
                {`Hi ${user?.DisplayName}, I am Ana, your business analytics expert. Below is
                ${business?.business_name} current month analytics.`}
              </div>
            </div>
            {/* Analytics Cards */}
            <div
              className="my-5 mx-2 rounded-[7px]"
              style={{
                boxShadow: "0px 2px 30px 0px rgba(0, 0, 0, 0.10)",
              }}
            >
              <MonthlyRevenueExpense
                erLoading={erLoading}
                monthlyExpense={monthlyExpense}
                monthlyRevenue={monthlyRevenue}
                ekkLanguage={ekkLanguage}
                startTime={startDay}
                endOfTime={endDay}
              />
            </div>
            <div
              className="my-5 mx-2 rounded-[7px]"
              style={{
                boxShadow: "0px 2px 30px 0px rgba(0, 0, 0, 0.10)",
              }}
            >
              <DepositAndPaymentDue
                dLoading={dLoading}
                epDLoading={epDLoading}
                depositExpenseDue={depositExpenseDue}
                ekkLanguage={ekkLanguage}
                startTime={startDay}
                endOfTime={endDay}
              />
            </div>
            <div
              className="my-5 mx-2 rounded-[7px]"
              style={{
                boxShadow: "0px 2px 30px 0px rgba(0, 0, 0, 0.10)",
              }}
            >
              <ServiceProviderAndTax
                serviceAmountAndTax={serviceAmountAndTax}
                sLoading={sLoading}
                tLoading={tLoading}
                ekkLanguage={ekkLanguage}
                startTime={startDay}
                endOfTime={endDay}
              />
            </div>
            <div
              className="my-5 mx-2 rounded-[7px]"
              style={{
                boxShadow: "0px 2px 30px 0px rgba(0, 0, 0, 0.10)",
              }}
            >
              <ProfitLossEmployee
                profitLoss={monthlyProfitLoss}
                employee={totalEmployee}
                plLoading={plLoading}
                employeeLoading={employeeLoading}
                startTime={startDay}
                endOfTime={endDay}
              />
            </div>
          </div>

          <div className="fixed bottom-0 w-full">
            <BazAiBottomChatArea
              from="dashboard"
              // textareaRef={textareaRef}
              messageData={messageData}
              // handleKeyDown={handleKeyDown}
              height={height}
              // handleInputChange={handleInputChange}
              // setComment={setComment}
              // comment={comment}
              // handleAssistant={handleAssistant}
              // timer={timer}
              // formatTime={formatTime}
              // getRootProps={getRootProps}
              // getInputProps={getInputProps}
              // handleTouchStart={handleTouchStart}
              // handleTouchEnd={handleTouchEnd}
              // ripple={ripple}
              // newSenderItemHandler={newSenderItemHandler}
              // updateBeforeLastDataHandler={
              //   updateBeforeLastDataHandler
              // }
              // updateLastDataHandler={updateLastDataHandler}
              // materials={materials}
              // user={user}
              // scrollToBottom={scrollToBottom}
            />
          </div>
          {/* <section className={`pt-14 ${!screenSize && "px-4"}`}>
						<AccountDashboard />
					</section> */}
          <DashboardBottomSheet />
        </IonContent>
      </IonPage>
    </IonApp>
  );
}
